import { render, staticRenderFns } from "./lista_aprobar.vue?vue&type=template&id=0f6de00c&scoped=true"
import script from "./lista_aprobar.vue?vue&type=script&lang=js"
export * from "./lista_aprobar.vue?vue&type=script&lang=js"
import style0 from "./lista_aprobar.vue?vue&type=style&index=0&id=0f6de00c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6de00c",
  null
  
)

export default component.exports